import { ROUTE_PATH } from 'modules/routes/constants/index.cjs'
import { defineMessages } from 'react-intl'

const messages = defineMessages({
  creators: {
    id: 'Footer.creators',
    defaultMessage: 'Creators'
  },
  supporters: {
    id: 'Footer.supporters',
    defaultMessage: 'Supporters'
  },
  contactUs: {
    id: 'Footer.contactUs',
    defaultMessage: 'Contact Us'
  },
  login: {
    id: 'Footer.login',
    defaultMessage: 'Login'
  },
  about: {
    id: 'Footer.about',
    defaultMessage: 'About'
  },
  careers: {
    id: 'Footer.careers',
    defaultMessage: 'Careers'
  },
  privacy: {
    id: 'Footer.privacy',
    defaultMessage: 'Privacy'
  },
  terms: {
    id: 'Footer.terms',
    defaultMessage: 'Terms'
  },
  faq: {
    id: 'Footer.faq',
    defaultMessage: 'FAQ'
  },
  instagram: {
    id: 'Footer.instagram',
    defaultMessage: 'Instagram'
  },
  tiktok: {
    id: 'Footer.tiktok',
    defaultMessage: 'TikTok'
  },
  etsy: {
    id: 'Footer.etsy',
    defaultMessage: 'Etsy'
  },
  x: {
    id: 'Footer.x',
    defaultMessage: 'X'
  },
  facebook: {
    id: 'Footer.facebook',
    defaultMessage: 'Facebook'
  },
  tumblr: {
    id: 'Footer.tumblr',
    defaultMessage: 'Tumblr'
  },
  telegram: {
    id: 'Footer.telegram',
    defaultMessage: 'Telegram'
  },
  pinterest: {
    id: 'Footer.pinterest',
    defaultMessage: 'Pinterest'
  }
})

export const navItems = [
  {
    name: messages.creators,
    path: ROUTE_PATH.CREATOR
  },
  {
    name: messages.supporters,
    path: ''
  },
  {
    name: messages.contactUs,
    path: ROUTE_PATH.CONTACT
  },
  {
    name: messages.login,
    path: ROUTE_PATH.CREATOR_LOGIN
  }
]

export const navItemsFooter = [
  {
    name: messages.about,
    path: ROUTE_PATH.ABOUT
  },
  {
    name: messages.contactUs,
    path: ROUTE_PATH.CONTACT
  },
  // {
  //   name: messages.careers,
  //   path: ROUTE_PATH.CAREERS
  // },
  {
    name: messages.privacy,
    path: ROUTE_PATH.PRIVACY
  },
  {
    name: messages.terms,
    path: ROUTE_PATH.APP_TERMS
  },
  {
    name: messages.faq,
    path: ROUTE_PATH.FAQ
  }
]

export const socialLinks = [
  {
    name: messages.instagram,
    path: '//instagram.com/gymaholic'
  },
  {
    name: messages.x,
    path: '//x.com/gymaholic'
  },
  {
    name: messages.tiktok,
    path: '//tiktok.com/@gymaholic.co'
  },
  {
    name: messages.tumblr,
    path: '//gymaaholic.tumblr.com'
  },
  {
    name: messages.pinterest,
    path: '//pinterest.com/gymaaholic'
  },
  {
    name: messages.telegram,
    path: '//t.me/gymaholic_app'
  },
  {
    name: messages.facebook,
    path: '//facebook.com/gymaholic'
  },
  {
    name: messages.etsy,
    path: '//etsy.com/shop/GymaholicStore'
  }
]
